module.exports = __webpack_public_path__ + "img/slider_text_b2.8425a19.d88ca674.png";